/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DetailItem } from '../../../../resources/quote-structure.model';

@Component({
  selector: 'gh-quote-structure-detail-item',
  template: require('./quote-structure-detail-item.component.html'),
  styles: [require('./quote-structure-detail-item.component.scss')],
})
export class QuoteStructureDetailItemComponent {
  @Input() detail: DetailItem;
  @Input() disableChanging: boolean;

  @Output() detailEdit = new EventEmitter<DetailItem>();
  @Output() detailRemove = new EventEmitter<DetailItem>();

  edit(): void {
    this.detailEdit.emit(this.detail);
  }

  remove(): void {
    this.detailRemove.emit(this.detail);
  }
}
